import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../core/validation/validation.service';
import { ValidationModel } from './validation-model';

@Injectable({
  providedIn: 'root',
})
export class FactoryFormControlBuilder {
  constructor(
    private _formBuilder: FormBuilder,
    private _validation: ValidationService
  ) {}
  buildFormWithModel(
    formGroup: FormGroup,
    formControlName: string,
    validationList: ValidationModel[],
    required = false
  ) {
    this._buildFormControl(formGroup, formControlName);
    this._buildFormValidation(
      formGroup,
      formControlName,
      validationList,
      required
    );
  }

  private _buildFormControl(formGroup: FormGroup, formControlName: string) {
    if (!formGroup.controls[formControlName]) {
      formGroup.addControl(formControlName, this._formBuilder.control(''));
    }
  }

  private _buildFormValidation(
    formGroup: FormGroup,
    formControlName: string,
    validationList: ValidationModel[],
    required = false
  ) {
    // Get the control
    const control = formGroup.get(formControlName);
    if (!control) {
      throw new Error(`Control with name ${formControlName} not found in form`);
    }
    control.clearValidators();

    let validators = [];
    if (validationList) {
      validators = validationList
        .filter(v => !!!v.virtual)
        .map((v, i) => {
          const validatorName = v.validatorName || v.errorKey;
          return this._validation.getValidatorByKey(
            validatorName,
            v.errorKey,
            v.args
          );
        });
    }

    if (required) {
      validators.push(Validators.required);
    }

    control.setValidators(validators);
  }
}
